import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors, getSpacing } from '../utils';

const getWidth = props => {
  if (props.wrapper) {
    return '195px';
  }

  return '100%';
};

const getColor = props => {
  if (props.color in colors) {
    return colors[props.color];
  }

  if (props.theme === 'bordered') {
    return 'transparent';
  }

  if (props.theme === 'facebook') {
    return colors.f03;
  }

  if (props.disabled) {
    return colors.g02;
  }

  if (props.error) {
    return colors.r01;
  }

  return colors.b01;
};

const getTextColor = props => {
  if (props.textColor in colors) {
    return colors[props.color];
  }

  if (props.disabled) {
    return props.theme === 'bordered' ? colors.g02 : colors.w01;
  }

  if (props.theme === 'bordered') {
    return colors.b01;
  }

  return colors.w01;
};

const getHoverTextColor = props => {
  if (props.disabled) {
    return props.theme === 'bordered' ? colors.g02 : colors.w01;
  }

  if (props.theme === 'bordered') {
    return colors.b02;
  }

  return colors.w01;
};

const getHoverColor = props => {
  if (props.disabled) {
    return props.theme === 'bordered' ? 'transparent' : colors.g02;
  }

  if (props.theme === 'bordered') {
    return 'transparent';
  }

  if (props.error) {
    return colors.r02;
  }

  if (props.theme === 'facebook') {
    return colors.f02;
  }

  return colors.b02;
};

export const Button = styled.button`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  background-color: ${getColor};
  border: 1px solid ${props => (props.disabled ? colors.g02 : colors.b01)};
  border-radius: 4px;
  color: ${getTextColor};
  cursor: ${props => (props.disabled ? 'inherit' : 'pointer')};
  font-size: ${props => props.fontSize}px;
  font-family: Mada;
  font-weight: bold;
  height: 40px;
  margin: ${props => getSpacing(props.margin)};
  padding: ${props => getSpacing(props.padding)};
  width: ${getWidth};

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${props => getHoverColor(props)};
    box-shadow: ${props =>
        props.disabled || props.theme !== 'bordered'
          ? 'none'
          : `1px 1px 0 ${colors.b02} inset, -1px -1px 0 ${colors.b02} inset, -1px 1px 0 ${colors.b02} inset,
      1px -1px 0 ${colors.b02}`}
      inset;
    color: ${props => getHoverTextColor(props)};
  }
`;

Button.defaultProps = {
  fontSize: 16,
  margin: 'auto',
  padding: 'none',
  theme: 'default'
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]).isRequired,
  fontSize: PropTypes.number,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  theme: PropTypes.oneOf(['default', 'bordered', 'facebook'])
};
